@if (show !== undefined ? show : (serverStatusService.isOnline$ | async) === false) {
  <div
    class="offline-banner"
    [ngClass]="[type, compact ? 'compact' : '']"
    >
    <mat-icon>{{ icon }}</mat-icon>
    <p>{{ message }}</p>
  </div>
}
